import React, { useState } from 'react';

import { useMutation } from '@tanstack/react-query';

import Table from '../../../../Table';
import AddOrEditTradelineModal from './AddOrEditTradelineModal';

import { useUiStore } from '../../../../../store';
import CreditReportTradelineService from '../../../../../services/CreditReportTradelineService';

const cols = [
  {
    title: 'Creditor',
    key: 'creditor',
  },
  {
    title: 'Type',
    key: 'type',
  },
  {
    title: 'Balance',
    key: 'balance',
    type: 'currency',
  },
  {
    title: 'Payment',
    key: 'payment',
    type: 'currency',
  },
  {
    title: 'Past due',
    key: 'pastDue',
    type: 'currency',
  },
  {
    title: 'Status',
    key: 'status',
  },
  {
    title: 'Real Estate',
    key: 'isRealEstate',
    type: 'checkbox',
  },
  {
    title: 'Pay Off',
    key: 'isPayOff',
    type: 'checkbox',
  },
  {
    title: 'Pay Off Verified',
    key: 'isPayOffVerified',
    type: 'checkbox',
  },
];

export default function Tradelines({ creditReport, refetchBorrowers }) {
  const [isAddOrEditModalVisible, setIsAddOrEditModalVisible] = useState(false);
  const [currentTradeline, setCurrentTradeline] = useState(null);

  const showDialogModal = useUiStore((state) => state.showDialogModal);
  const notifySuccess = useUiStore((state) => state.notifySuccess);
  const notifyApiError = useUiStore((state) => state.notifyApiError);

  const { mutate: deleteCreditReportTradeline } = useMutation({
    mutationFn: (id) =>
      CreditReportTradelineService.deleteCreditReportTradeline(id),
    onSuccess: () => {
      refetchBorrowers();
      notifySuccess('Tradeline deleted successfully.');
    },
    onError: (error) => {
      console.log(error);
      notifyApiError(error);
    },
  });

  const actions = [
    {
      title: 'Edit',
      onClick: (row) => {
        setCurrentTradeline(row);
        setIsAddOrEditModalVisible(true);
      },
      icon: 'edit',
    },
    {
      title: 'Delete',
      onClick: (row) =>
        showDialogModal({
          title: 'Delete Tradeline',
          text: `Are you sure you want to delete this tradeline?`,
          onConfirm: () => deleteCreditReportTradeline(row.id),
        }),
      icon: 'delete',
      danger: true,
    },
  ];

  return (
    <div>
      <Table
        countName="Tradelines"
        cols={cols}
        rows={creditReport?.CreditReportTradelines || []}
        createButtonLabel="Add Tradeline"
        onCreateButtonClick={() => {
          setCurrentTradeline(null);
          setIsAddOrEditModalVisible(true);
        }}
        totalCells={['balance', 'payment', 'pastDue']}
        actions={actions}
      />
      <AddOrEditTradelineModal
        isVisible={isAddOrEditModalVisible}
        hideModal={() => setIsAddOrEditModalVisible(false)}
        creditReportId={creditReport?.id}
        refetchBorrowers={refetchBorrowers}
        data={currentTradeline}
      />
    </div>
  );
}
